/*
* Copyright (c) Microsoft Corporation. All rights reserved.
* Licensed under the MIT License.
*/

import { LogLevel } from "@azure/msal-browser";

/**
* Configuration object to be passed to MSAL instance on creation.
* For a full list of MSAL.js configuration parameters, visit:
* https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
*/

const config = {
    appId: process.env.REACT_APP_AZ_APP_ID,
    redirectUri: process.env.REACT_APP_AZ_REDIRECT_URI,
    scopes: [
        "user.read",
        "Mail.Send",
        "Mail.ReadWrite"
    ]
}

export const msalConfig = {
    auth: {
        clientId: config.appId,// This is the ONLY mandatory field that you need to supply.
        redirectUri: config.redirectUri,// Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        // authority: process.env.REACT_APP_AZ_AUTHORITY,// Defaults to "https://login.microsoftonline.com/common"
        authority: 'https://login.microsoftonline.com/f8c68086-b95c-49cb-9d38-ed37940abef5/',// Defaults to "https://login.microsoftonline.com/common"
        postLogoutRedirectUri: config.redirectUri // Indicates the page to navigate after logout.
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {    
        loggerOptions: {    
            loggerCallback: (level, message, containsPii) => {    
                if (containsPii) {        
                    return;        
                }        
                switch (level) {        
                    case LogLevel.Error:        
                        console.error(message);        
                        return;        
                    case LogLevel.Info:        
                        return;        
                    case LogLevel.Verbose:        
                        console.debug(message);        
                        return;        
                    case LogLevel.Warning:        
                        console.warn(message);        
                        return;    
                    default:
                        return;
                }    
            }    
        }    
    }
};

/**
* Scopes you add here will be prompted for user consent during sign-in.
* By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
* For more information about OIDC scopes, visit:
* https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
*/
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
* Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
* https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
*/
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/beta/me"
};